"use client";

import VoyadoSignUpForm from "@app/_components/VoyadoSignupForm/VoyadoSignUpForm";
import TradeAccountForm from "@app/_forms/TradeAccountForm";
import BookMeeting from "@forms/bookMeeting";
import Claims from "@forms/claims";
import Contact from "@forms/contact";
import MatchPrice from "@forms/matchPrice";
import NewCustomerForm from "@forms/newCustomer";
import Return from "@forms/return";
import type { FormFragment } from "@server/gql/graphql";

import { transformStringToSnakeCase } from "@/utils/common";

/**
 * @todo The Form.tsx needs a refactor to be more dynamic and reusable.
 * We cant have this mess of dictionaries, if statements and different props for each form.
 */
export default function Form({
  locale,
  className,
  name,
  reference,
  ...props
}: FormFragment & {
  className?: string;
  locale?: string;
}) {
  if (!name) return null;

  const formName = transformStringToSnakeCase(name);

  if (formName === "contact_form" && reference)
    return <Contact reference={reference} {...props} />;
  if (formName === "match_price_form" && reference)
    return <MatchPrice reference={reference} {...props} />;
  if (formName === "return_form" && reference)
    return <Return reference={reference} {...props} />;
  if (formName === "claims_form" && reference)
    return <Claims reference={reference} {...props} />;
  if (formName === "newsletter_form") return <NewCustomerForm />;
  if (formName === "book_meeting_form" && reference) {
    return <BookMeeting reference={reference} {...props} />;
  }
  if (formName === "trade_account_form" && reference) {
    return <TradeAccountForm className={className} reference={reference} />;
  }

  if (formName.includes("voyado")) {
    return (
      <VoyadoSignUpForm
        className={className}
        locale={locale}
        reference={reference}
      />
    );
  }

  return null;
}
